<template>
    <div class="horizontal">
        <div style="width: 18%; min-width: 250px; margin-right: 10px;">
            <div class="horizontal" style="margin: 5px 10px;">
                <img src="@/assets/img/Systems/Animals/search.svg" style="margin: 5px;">
                <input v-model="searchResult" type="number" step="1" style="width: 100%; border: 1px solid #414F51; border-radius: 5px;"/>
            </div>
            <div class="animal-scroll">
                <!-- Stan ładowania: puste karty skeleton -->
                <template v-if="loadingAnimals">
                    <div v-for="n in 6" :key="'skeleton-' + n" class="animal-card skeleton-card">
                        <div class="skeleton-line" style="width: 40%;"></div>
                        <div class="skeleton-line" style="width: 70%;"></div>
                        <div class="skeleton-line" style="width: 60%;"></div>
                        <div class="skeleton-line" style="width: 65%;"></div>
                    </div>
                </template>
                <!-- Stan pusty: brak zwierząt po załadowaniu -->
                <div v-else-if="animals.length == 0" class="empty-state">
                    {{ $t('No animals to display') }}
                </div>
                <div v-for="animal in animals" :key="animal.id">
                    <div class="animal-card" style="cursor: pointer;" @click="selectedAnimal = animal">
                        <div class="horizontal" style="justify-content: space-between;">
                            <div class="horizontal">
                                <div v-if="animal.isAlarmOff"><img src="@/assets/img/Systems/Animals/no_alarm.svg" style="margin-right: 5px; padding: 3px 5px;"></div>
                                <h5>{{ animal.animalNumber }}</h5>
                            </div>
                            <span style="font-size: 12px; color: gray;">{{ animal.transponderNumber }}</span>
                        </div>
                        <div style="display: flex;" v-if="systemData != null && systemData.hasWeight">
                            <img src="@/assets/img/Systems/Animals/weight.svg" style="margin-right: 5px; padding: 3px 5px;">
                            <span style="font-size: 14px; align-self: center;">{{ (animal.weight / 1000).toFixed(2) }} {{ systemUnit }}</span>
                        </div>
                        <div style="display: flex;">
                            <img src="@/assets/img/Systems/Animals/visit_number.svg" style="margin-right: 5px; padding: 3px 5px;">
                            <div class="horizontal">
                                <span style="font-size: 14px; align-self: center; border-right: 1px solid white; padding-right: 5px;">T: {{ animal.visitsRoughageToday }}</span>
                                <span style="font-size: 14px; align-self: center; padding-left: 5px;">Y: {{ animal.visitsRoughageYesterday }}</span>
                            </div>
                        </div>
                        <div style="display: flex;">
                            <img src="@/assets/img/Systems/Animals/eat.svg" style="margin-right: 5px; padding: 3px 5px;">
                            <div class="horizontal">
                                <span style="font-size: 14px; align-self: center; border-right: 1px solid white; padding-right: 5px;">T: {{ (animal.eatenRoughageToday / 1000.0).toFixed(2) }} {{ systemUnit }}</span>
                                <span style="font-size: 14px; align-self: center; padding-left: 5px;">Y: {{ (animal.eatenRoughageYesterday / 1000.0).toFixed(2) }} {{ systemUnit }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedAnimal == null" class="placeholder-panel">
            <span>{{ $t('Select an animal to see details') }}</span>
        </div>
        <div v-else style="width: 82%; max-height: calc(100vh - 50px); overflow: auto;">
            <div class="details-card">
                <div style="justify-content: space-between;">
                    <div class="horizontal">
                        <div v-if="selectedAnimal.isAlarmOff"><img src="@/assets/img/Systems/Animals/no_alarm.svg" style="margin-right: 5px; padding: 3px 5px;"></div>
                        <h3>{{ selectedAnimal.animalNumber }}</h3>
                    </div>
                    <div style="font-size: 14px; color: gray;">
                        {{ $t('Transponder') }}:
                        <span style="color: white;">{{ selectedAnimal.transponderNumber }}</span>
                    </div>
                    <div style="font-size: 14px; color: gray;" v-if="systemData != null && systemData.hasWeight">
                        {{ $t('Weight') }}:
                        <span style="color: white;">{{ (selectedAnimal.weight / 1000).toFixed(2) }} {{ systemUnit }}</span>
                    </div>
                    <div style="font-size: 14px; color: gray;">
                        {{ $t('LastVisit') }}:
                        <span style="color: white;">{{ moment(selectedAnimal.lastVisit).format('YYYY-MM-DD HH:mm:ss') }}</span>
                    </div>
                </div>
            </div>
            <div style="display: grid; grid-template-rows: auto; grid-template-columns: 50% 50%;">
                <div class="herd-card" v-if="systemData != null && systemData.hasWeight">
                    <h5>{{ $t('Weight') }}</h5>
                    <sci-chart-animal-data v-if="!loadingWeight" style="position: relative;" :sid="'weight-' + selectedAnimal.id" :chartData="weightData" :unit="systemUnit"/>
                    <Spinner v-else style="width: 100%; position: relative;"></Spinner>
                </div>
                <div class="herd-card" v-if="loadingRoughage">
                    <h5>{{ $t('Feeding') }}</h5>
                    <Spinner style="width: 100%; position: relative;"></Spinner>
                </div>
                <div class="herd-card" v-for="roughageType in roughageData" :key="roughageType.label">
                    <h5>{{ roughageType.label }} {{ $t('Feeding') }}</h5>
                    <sci-chart-animal-data style="position: relative;" :sid="'roughage-' + selectedAnimal.id" :chartData="mapConsumption(roughageType)" :unit="systemUnit"/>
                </div>
                <div class="herd-card" v-if="loadingVisits">
                    <h5>{{ $t('Visits') }}</h5>
                    <Spinner style="width: 100%; position: relative;"></Spinner>
                </div>
                <div class="herd-card" v-for="visitsType in visitsData" :key="visitsType.label">
                    <h5>{{ visitsType.label }} {{ $t('Visits') }}</h5>
                    <sci-chart-animal-data style="position: relative;" :sid="'visit-' + selectedAnimal.id" :chartData="mapVisits(visitsType)" :unit="''"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getAnimals, getAnimalWeightChart, getAnimalConsumptionChart, getAnimalVisitsChart } from '@/api/api';
import SciChartAnimalData from '../../components/Charts/SciChartAnimalData.vue';
import Spinner from 'vue-simple-spinner'

// { "animalNumber": "1366", "transponderNumber": "250269701366", "weight": 664578.3333333334, "isAlarmOff": false, "lastVisit": "2024-06-19T12:19:12.647", "eatenRoughageToday": 23963, "eatenRoughageYesterday": 942, "eatenConcentrateToday": 0, "eatenConcentrateYesterday": 0, "eatenWaterToday": 0, "eatenWaterYesterday": 0, "eatenMilkToday": 0, "eatenMilkYesterday": 0, "visitsRoughageToday": 36, "visitsRoughageYesterday": 1, "visitsConcentrateToday": 0, "visitsConcentrateYesterday": 0, "visitsWaterToday": 0, "visitsWaterYesterday": 0, "visitsMilkToday": 0, "visitsMilkYesterday": 0, "id": "1536852e-f305-4532-a43c-65c599e6b3f9" }

export default {
    components: { 
        SciChartAnimalData,
        Spinner
    },
    props: {
        systemId: {

        },
        systemName: {

        },
        systemData: {

        }
    },
    computed: {
        animals() {
            return this.originalAnimals.filter(x => this.searchResult != '' ? x.animalNumber.startsWith(this.searchResult) : true)
                .sort((x, y) => x.animalNumber - y.animalNumber)
        },
        systemUnit() {
            if (this.systemData == null || this.systemData.weightUnit == undefined) 
                return 'kg';

            return ['kg', 'kg', 'lbs'][this.systemData.weightUnit + 1] 
        }
    },
    watch: {
        selectedAnimal(newVal, oldVal) {
            this.weightData = {values: [], labels: []};
            this.loadingWeight = true;
            this.loadingRoughage = true;
            this.loadingVisits = true;
            this.visitsData = [];
            this.roughageData = [];

            getAnimalWeightChart(this.systemId, newVal.id).then((result) => {
                var wData = { values: [], labels: [] }
                for(let i = 0; i < result.values.length; i++) {
                    if(result.values[i] != 0) {
                        wData.values.push((result.values[i] / 1000).toFixed(2));
                        wData.labels.push(result.labels[i]);
                    }
                }
                this.weightData = wData;
                this.loadingWeight = false;
            });
            
            getAnimalConsumptionChart(this.systemId, newVal.id).then((result) => {
                this.roughageData = result;
                this.loadingRoughage = false;
            });

            getAnimalVisitsChart(this.systemId, newVal.id).then((result) => {
                this.visitsData = result;
                this.loadingVisits = false;
            });

            
        }
    },
    data() {
        return {
            // animals: [],
            originalAnimals: [],
            selectedAnimal: null,
            searchResult: '',
            weightData: {},
            roughageData: {},
            visitsData: {},
            loadingAnimals: true,
            loadingWeight: false,
            loadingRoughage: false,
            loadingVisits: false
        }
    },
    methods: {
        getData() {
            this.loadingAnimals = true;
            getAnimals(this.systemId).then((result) => {
                this.originalAnimals = result;
                // this.animals = this.originalAnimals;
                this.loadingAnimals = false;
            }).catch(() => {
                this.loadingAnimals = false;
            })
        },
        mapVisits(v){
            return {
                values: v.data.map(x => x.value),
                labels: v.data.map(x => x.date)
            }
        },
        mapConsumption(v){
            console.dir(v)
            return {
                values: v.data.map(x => (x.value / 1000)),
                labels: v.data.map(x => x.date)
            }
        }
    },
    async mounted() {
        this.getData();
    }
}
</script>

<style scoped>
.animal-card {
    color: white;
    padding: 5px 10px;
    margin: 5px 10px;
    background: #414F51;
    border: 1px solid #30383a;
    border-radius: 5px;
    transition-duration: 0.5s;
}

.animal-card:hover {
    background: #30383a;
}

.animal-scroll {
    max-height: calc(100vh - 100px); 
    overflow: auto;
}

.details-card {
    color: white;
    padding: 5px 10px;
    margin: 5px 10px;
    background: #414F51;
    border: 1px solid #30383a;
    border-radius: 5px;
    width: 98%;
}

.herd-card {
    color: white;
    padding: 5px 10px;
    margin: 5px 10px;
    background: #414F51;
    border: 1px solid #30383a;
    border-radius: 5px;
    transition-duration: 0.5s;
}

/* Skeleton — puste karty podczas ładowania listy zwierząt */
.skeleton-card {
    cursor: default;
}

.skeleton-card:hover {
    background: #414F51;
}

.skeleton-line {
    height: 14px;
    margin: 8px 0;
    border-radius: 4px;
    background: linear-gradient(90deg, #4d5b5d 25%, #5c6b6d 37%, #4d5b5d 63%);
    background-size: 400% 100%;
    animation: skeleton-loading 1.4s ease infinite;
}

@keyframes skeleton-loading {
    0% { background-position: 100% 50%; }
    100% { background-position: 0 50%; }
}

/* Stan pusty — brak zwierząt do wyświetlenia */
.empty-state {
    color: gray;
    text-align: center;
    padding: 20px 10px;
    font-size: 14px;
}

/* Placeholder prawego panelu — brak wybranego zwierzęcia */
.placeholder-panel {
    width: 82%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: gray;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/System/SystemAnimals.vue